import { strEnum } from "../../types";

export const TCI_LOG_ACTION_TYPE = strEnum([
    "historical",
    "realtime",
    "download"
]);
export type TCI_LOG_ACTION_TYPE = keyof typeof TCI_LOG_ACTION_TYPE;

export const TCI_LOG_VIEW_STYLES = strEnum<string>([
    "raw",
    "table"
]);
export type TCI_LOG_VIEW_STYLES = keyof typeof TCI_LOG_VIEW_STYLES;

export const TCI_QUERY_STYLES = strEnum<string>([
    "history",
    "tail"
]);
export type TCI_QUERY_STYLES = keyof typeof TCI_QUERY_STYLES;

export const TCI_LOG_MODES = strEnum([
    "realtime_active",
    "realtime_inactive",
    "historical"
]);

export type TCI_LOG_MODES = keyof typeof TCI_LOG_MODES;

export const TCI_LOG_QUERY_PARAMS = strEnum([
    "app_id",
    "index",
    "start_row",
    "fetch_size",
    "style",
    "time_slot",
    "start_time",
    "end_time"
]);

export type TCI_LOG_QUERY_PARAMS = keyof typeof TCI_LOG_QUERY_PARAMS;

export const TCI_LOG_CATEGORIES = strEnum<string>([
    "buildtime",
    "runtime"
]);
export type TCI_LOG_CATEGORIES = keyof typeof TCI_LOG_CATEGORIES;

export const TCI_TIME_RANGE_MEASURES = strEnum<string>([
    "TIME_MINS",
    "TIME_HOUR",
    "TIME_HOURS",
    "TIME_DAYS"
]);
export type TCI_TIME_RANGE_MEASURES = keyof typeof TCI_TIME_RANGE_MEASURES;

export const TCI_LOG_LEVEL_IDS = strEnum<string>([
    "INFO",
    "DEBUG",
    "WARN",
    "ERROR",
    "N/A"
]);
export type TCI_LOG_LEVEL_IDS = keyof typeof TCI_LOG_LEVEL_IDS;

export const TCI_TIME_RANGE_IDS = strEnum<string>([
    "5m",
    "30m",
    "1h",
    "12h",
    "24h",
    "7d",
    "30d",
    "custom"
]);
export type TCI_TIME_RANGE_IDS = keyof typeof TCI_TIME_RANGE_IDS;

export const TCI_QUERY_REQUEST_ORDER = strEnum<string>([
    "DESC",
    "ASC"
]);
export type TCI_QUERY_REQUEST_ORDER = keyof typeof TCI_QUERY_REQUEST_ORDER;

/**
 * For real-time request
 */
export interface ITCILogRequest {
    appId: string;
    style?: TCI_QUERY_STYLES;
    clientTimeZone?: string;
    logLevels?: TCI_LOG_LEVEL_IDS[];
    startRow?: number;
    fetchSize?: number;
}

/**
 * For historical and download logs request
 */
export interface ITCILogHistoryRequest extends ITCILogRequest {
    timeSlot?: TCI_TIME_RANGE_IDS;
    startTime?: string;
    endTime?: string;
    limitMaximumRows?: number;
}

export interface ITCILogResult {
    /**
     * Log message id
     */
    id: string;
    /**
     * Log time in milliseconds
     */
    time: number;
    /**
     * Log message level -> INFO, DEBUG, WARN, ERROR
     */
    logLevelId: TCI_LOG_LEVEL_IDS;
    /**
     * Log message string
     */
    message: string;
}

export interface ITCILogContent {
    /**
     * Log total count
     */
    totalCount?: number;
    /**
     * Is log proccessing finished flag for UI polling (not in use currently)
     */
    finished?: string;
    /**
     * Log query time (not in use currently)
     */
    queryTime?: number;
    /**
     * Log result object
     */
    results?: ITCILogResult[];
}

export interface ITCILogResponse {
    /**
     * Log response code
     */
    code?: string | number;
    /**
     * Log response message
     */
    message?: string;
    /**
     * Log response content
     */
    content?: ITCILogContent;
}

export interface ITCILogErrResponse {
    code?: string | number;
    message?: string;
    body?: any;
}

export interface ITCILogLevel {
    id: TCI_LOG_LEVEL_IDS;
    label: string;
    value: boolean;
    status: string;
}

export interface ITCILogTimeRange {
    id: TCI_TIME_RANGE_IDS;
    label: string;
    /**
     * Time in milliseconds
     */
    value: number;
    measure: TCI_TIME_RANGE_MEASURES;
}

export interface ITCILogESIndex {
    indexName: string;
}
